var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',_vm._l((_vm.data),function(month){return _c('td',{class:{ 'current-month': month.month === _vm.currentMonth }},[_vm._v("\n        "+_vm._s(_vm._f("number")(month.forecasts_quantity))+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }